export enum GatewayEndPoint {
  Execute = 'gateway/execute/',
  Distinct = 'gateway/aggregate/distinct/',
}

export enum EntityLockEndPoint {
  Get = 'frontend/entity/lock/get/',
  Set = 'frontend/entity/lock/set/',
  Unset = 'frontend/entity/lock/unset/',
}
